import React from "react";
import classNames from "classnames";

import { ActivityWatcher } from "@common/activityWatcher";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { useScreenWatcher } from "@common/screenWatcher";
import { Props } from "./types";
import styles from "./styles.scss";

function SelectList<Item>(props: Props<Item>) {
  const visibilityBehavior = props.visibilityBehavior || "rendered";
  const ref = React.useRef<HTMLDivElement>(null);
  const { isVisible, show, hide } = VisibilitySwitch.useVisibilitySwitch();
  const { input, list } = props.children({
    isOpen: isVisible,
    show,
    hide,
    select: (item) => {
      !props.multiple && hide();
      return item;
    },
  });
  const rootClassName = props.rootClassName
    ? typeof props.rootClassName === "function"
      ? props.rootClassName(isVisible)
      : props.rootClassName
    : "";

  ActivityWatcher.useActivityWatcher(ref, {
    focus: () => !props.isDisabled && !isVisible && show(),
    blur: hide,
  });

  return (
    <div
      className={classNames(styles.selectList, {
        [`${rootClassName}`]: rootClassName,
        [styles.opened]: isVisible,
        [styles.displayBehavior]: visibilityBehavior === "displayed",
      })}
      ref={ref}
    >
      <div
        className={classNames(styles.input, {
          [`${props.inputClassName}`]: !!props.inputClassName,
        })}
        onClick={(e) => {
          isVisible && e.stopPropagation();
          !props.isDisabled && (isVisible ? hide() : show());
        }}
      >
        {input}
      </div>
      {visibilityBehavior === "rendered" && isVisible ? (
        <div
          className={classNames(styles.list, {
            [`${props.listClassName}`]: !!props.listClassName,
          })}
          style={props.listStyle}
        >
          {list}
        </div>
      ) : (
        visibilityBehavior === "displayed" && (
          <div
            className={classNames(styles.list, {
              [`${props.listClassName}`]: !!props.listClassName,
            })}
          >
            {list}
          </div>
        )
      )}
    </div>
  );
}

export { SelectList };
